<template>
<div>
    <el-form :inline="true" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="快递公司名称:">
            <el-input size="small" v-model="dataForm.name" placeholder="快递公司名称" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item class="fr">
            <el-button size="small" @click="getDataList()" icon="el-icon-search">
                查询
            </el-button>
            <el-button size="small" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                添加
            </el-button>
        </el-form-item>
    </el-form>
    <div v-loading="dataListLoading">
        <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
            <el-table-column type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column prop="name" header-align="left" align="left" label="快递公司名称">
            </el-table-column>
            <el-table-column prop="code" header-align="left" align="left" label="快递公司编码">
                <template slot-scope="scope">
                    {{ scope.row.code || '-' }}
                </template>
            </el-table-column>
            <el-table-column header-align="center" align="left" width="140" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
</div>
</template>

<script>
import {
    fetchExpressCompanyList,
    deleteExpressCompany
} from '@/controller/systemData'
import AddOrUpdate from './express-company-add-or-update'
export default {
    data() {
        return {
            dataForm: {
                name: ''
            },
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 280
            }
        }
    },
    components: {
        AddOrUpdate
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchExpressCompanyList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'name': this.dataForm.name
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 新增
        addOrUpdateHandle() {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init()
            })
        },
        // 删除
        deleteHandle(row) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteExpressCompany({}, row.id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    }
}
</script>
